// ═══════════════════════════════════════════════════════════════════
//  modules/tickets/Tickets.js
//  Tickets
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { PRIORITY_COLORS, STATUS_COLORS } from "./constantes";
import { TicketDetail } from "./TicketDetail";

export function Tickets({ token, cible, onNavigate }) {
  const [tickets, setTickets] = useState([]);
  const [selected, setSelected] = useState(null);
  // Lot 3 — arrivée depuis une page du wiki : on ouvre le ticket visé
  const [retour, setRetour] = useState(null);
  useEffect(() => {
    if (cible && cible.type === "ticket" && cible.id) {
      setSelected(Number(cible.id));
      setRetour(cible.retour || null);
    }
  }, [cible]);

  const loadTickets = useCallback(async () => {
    const res = await fetch(`${API_BASE}/api/tickets`, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    setTickets(Array.isArray(data) ? data : []);
  }, [token]);

  useEffect(() => { loadTickets(); }, [loadTickets]);

  if (selected) return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {retour && (
        <button onClick={() => onNavigate && onNavigate("wiki", retour)}
          style={{ alignSelf: "flex-start", background: THEME.purpleDim, border: `1px solid ${THEME.purple}`, color: THEME.purple, borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontSize: 12.5, fontWeight: 600 }}>
          ← Retour à « {retour.titre || "la page du wiki"} »
        </button>
      )}
      <TicketDetail ticketId={selected} token={token}
        onBack={() => { setSelected(null); setRetour(null); }} onUpdated={loadTickets} />
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <h2 style={{ color: THEME.text, fontSize: 18, fontWeight: 700, margin: 0 }}>🎫 Tickets de modération</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {tickets.length === 0 && <div style={{ color: THEME.textMuted }}>Aucun ticket pour l'instant.</div>}
        {tickets.map((t) => {
          const statusInfo = STATUS_COLORS[t.statut] || STATUS_COLORS.ouvert;
          const priorityInfo = PRIORITY_COLORS[t.priorite] || PRIORITY_COLORS.normale;
          return (
            <div key={t.id} onClick={() => setSelected(t.id)}
              style={{ background: THEME.panel, border: `1px solid ${t.statut === "ouvert" ? THEME.amber : THEME.border}`, borderRadius: 10, padding: "16px 20px", display: "flex", alignItems: "center", gap: 16, cursor: "pointer" }}>
              <div style={{ color: THEME.textMuted, fontSize: 12, fontWeight: 700, minWidth: 32 }}>#{t.id}</div>
              <div style={{ flex: 1 }}>
                <div style={{ color: THEME.text, fontWeight: 600, fontSize: 14, marginBottom: 6 }}>{t.categorie}</div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <span style={{ color: THEME.textMuted, fontSize: 12 }}>Discord ID {t.discord_user_id} · {new Date(t.ouvert_le).toLocaleDateString("fr")}</span>
                  <Badge text={statusInfo.label} bg={statusInfo.bg} color={statusInfo.text} />
                  <Badge text={t.priorite} bg={priorityInfo.bg} color={priorityInfo.text} />
                </div>
              </div>
              <span style={{ color: THEME.textMuted, fontSize: 12 }}>Ouvrir →</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
